import { SchemaRecord } from "../SchemaRecord.js";

export class DeviceLinkCancelParams extends SchemaRecord {
  static type = "chat.params.device_link_cancel";
  static schema = {};
}
